export const setSubSectionScore = (subSecId, score) => ({
    type: 'SET_SUBSECTION_SCORE',
    subSecId,
    score
})

export const setSectionScore = (secId, score) => ({
    type: 'SET_SECTION_SCORE',
    secId,
    score
})


// WEBPACK FOOTER //
// ./src/actions/score.js